import type { ReactNode } from 'react';
import { Dialog as D } from 'radix-ui';
import { X } from 'lucide-react';
import { cn } from './cn.js';

export const Dialog = D.Root;
export const DialogTrigger = D.Trigger;
export const DialogClose = D.Close;

/** Accessible modal (focus trap, Escape, focus return) restyled to the active surface tokens. */
export function DialogContent({
  title,
  description,
  children,
  className,
  wide,
}: {
  title: ReactNode;
  description?: ReactNode;
  children: ReactNode;
  className?: string;
  wide?: boolean;
}) {
  return (
    <D.Portal>
      <D.Overlay className="nw-overlay fixed inset-0 z-50 bg-[rgb(120_122_126/0.28)] backdrop-blur-[3px]" />
      <D.Content
        className={cn(
          'nw-dialog fixed inset-x-0 bottom-0 z-50 max-h-[92dvh] overflow-y-auto rounded-t-[var(--nw-radius-sheet)] border border-[var(--nw-glass-edge)] bg-[var(--nw-surface-solid)] p-5 backdrop-blur-2xl text-[var(--nw-ink)] shadow-[var(--nw-shadow-sheet)] sm:inset-auto sm:top-[8vh] sm:left-1/2 sm:w-[min(92vw,34rem)] sm:-translate-x-1/2 sm:rounded-[var(--nw-radius-sheet)] sm:p-7',
          wide && 'sm:w-[min(94vw,52rem)]',
          className,
        )}
      >
        <div className="mb-5 flex items-start justify-between gap-4">
          <div>
            <D.Title className="font-[family-name:var(--nw-font-display)] text-[1.7rem] leading-tight font-medium">{title}</D.Title>
            {description ? <D.Description className="mt-1 text-[0.95rem] text-[var(--nw-quiet)]">{description}</D.Description> : <D.Description className="sr-only">{title}</D.Description>}
          </div>
          <D.Close className="-me-2 -mt-1 grid size-11 shrink-0 place-items-center rounded-full text-[var(--nw-quiet)] hover:bg-[var(--nw-surface-sunk)] hover:text-[var(--nw-ink)]" aria-label="Close">
            <X className="size-5" />
          </D.Close>
        </div>
        {children}
      </D.Content>
    </D.Portal>
  );
}
